import { createSelector } from 'reselect';

const selectCalendarState = (state) => state.calendar;

const selectPaidSearchState = (state) => state.paidSearch;

const selectOverallPerformanceState = (state) => state.overallPerformance;

const selectOverallPerformanceSubBranchState = (state) => state.overallPerformanceSubBranch;

const selectAudienceAnalysisState = (state) => state.audienceAnalysis;

const selectChannelOppsState = (state) => state.channelOpps;

const selectSubBranchDashOppsByChannelState = (state) => state.subBranchDashOppsByChannel;

const selectPerformanceOverviewSubBranchState = (state) => state.performanceOverviewSubBranch;

const datePickerCombinedData = createSelector(selectCalendarState, (calendarState) => {
  return {
    calendarData: calendarState.calendarData,
    calendarDataWithDate: calendarState.calendarDataWithDate,
    transformedData: calendarState.formattedData,
    transformedDataWithDate: calendarState.formattedDataWithDate,
    quarterData: calendarState.quarterList,
    quarterDataForCompare: calendarState.quarterCompareList,
    quarterMenuList: calendarState.quarterMenuList,
    quarterMenuListForCompare: calendarState.quarterMenuListForCompare,
    yearMenuList: calendarState.yearMenuList,
    yearMenuListForCompare: calendarState.yearMenuListForCompare,
    currQuarter: calendarState.selectedQuarter,
    currYear: calendarState.selectedYear,
    comparisonQuarter: calendarState.comparisonQuarter,
    comparisonYear: calendarState.comparisonYear,
    boundaryValue: calendarState.boundaryValue,
    boundaryValueForCompare: calendarState.boundaryValueForCompare,
  };
});

const paidSearchCombinedData = createSelector(selectPaidSearchState, (paidSearchState) => ({
  type: paidSearchState.type,
  currentYear: paidSearchState.currentYear,
  currentQuarter: paidSearchState.currentQuarter,
  selectedYear: paidSearchState.selectedYear,
  selectedQuarter: paidSearchState.selectedQuarter,
  paidSearchRange: paidSearchState.paidSearchRange,
}));

const audienceAnalysisCombinedData = createSelector(
  selectAudienceAnalysisState,
  (audienceAnalysisState) => ({
    type: audienceAnalysisState.type,
    currentYear: audienceAnalysisState.currentYear,
    currentQuarter: audienceAnalysisState.currentQuarter,
    selectedYear: audienceAnalysisState.selectedYear,
    selectedQuarter: audienceAnalysisState.selectedQuarter,
    compareSelectedYear: audienceAnalysisState.compareSelectedYear,
    compareSelectedQuarter: audienceAnalysisState.compareSelectedQuarter,
    audienceAnalysisRange: audienceAnalysisState.audienceAnalysisRange,
    previousAudienceAnalysisRange: audienceAnalysisState.previousAudienceAnalysisRange,
    compareAudienceAnalysisRange: audienceAnalysisState.compareAudienceAnalysisRange,
  })
);

const channeledOppsCombinedData = createSelector(selectChannelOppsState, (channelOppsState) => ({
  type: channelOppsState.type,
  currentYear: channelOppsState.currentYear,
  currentQuarter: channelOppsState.currentQuarter,
  selectedYear: channelOppsState.selectedYear,
  selectedQuarter: channelOppsState.selectedQuarter,
  compareSelectedYear: channelOppsState.compareSelectedYear,
  compareSelectedQuarter: channelOppsState.compareSelectedQuarter,
  channelOppsRange: channelOppsState.channelOppsRange,
  previousChannelOppsRange: channelOppsState.previousChannelOppsRange,
  compareChannelOppsRange: channelOppsState.compareChannelOppsRange,
}));

const subBranchDashOppsByChannelCombinedData = createSelector(
  selectSubBranchDashOppsByChannelState,
  (subBranchDashOppsByChannelState) => ({
    type: subBranchDashOppsByChannelState.type,
    currentYear: subBranchDashOppsByChannelState.currentYear,
    currentQuarter: subBranchDashOppsByChannelState.currentQuarter,
    selectedYear: subBranchDashOppsByChannelState.selectedYear,
    selectedQuarter: subBranchDashOppsByChannelState.selectedQuarter,
    compareSelectedYear: subBranchDashOppsByChannelState.compareSelectedYear,
    compareSelectedQuarter: subBranchDashOppsByChannelState.compareSelectedQuarter,
    subDashChannelOppsRange: subBranchDashOppsByChannelState.subDashChannelOppsRange,
    previousChannelOppsRange: subBranchDashOppsByChannelState.previousChannelOppsRange,
    subDashCompareChannelOppsRange: subBranchDashOppsByChannelState.subDashCompareChannelOppsRange,
  })
);

const performanceOverviewSubBranchCombinedData = createSelector(
  selectPerformanceOverviewSubBranchState,
  (performanceOverviewSubBranchState) => ({
    type: performanceOverviewSubBranchState.type,
    currentYear: performanceOverviewSubBranchState.currentYear,
    currentQuarter: performanceOverviewSubBranchState.currentQuarter,
    selectedYear: performanceOverviewSubBranchState.selectedYear,
    selectedQuarter: performanceOverviewSubBranchState.selectedQuarter,
    compareSelectedYear: performanceOverviewSubBranchState.compareSelectedYear,
    compareSelectedQuarter: performanceOverviewSubBranchState.compareSelectedQuarter,
    performanceOverviewSubBranchRange:
      performanceOverviewSubBranchState.performanceOverviewSubBranchRange,
    previousChannelOppsRange: performanceOverviewSubBranchState.previousChannelOppsRange,
    performanceOverviewSubBranchCompareRange:
      performanceOverviewSubBranchState.performanceOverviewSubBranchCompareRange,
  })
);

const overallPerformanceCombinedData = createSelector(
  selectOverallPerformanceState,
  (overallPerformanceState) => ({
    type: overallPerformanceState.type,
    currentQuarter: overallPerformanceState.currentQuarter,
    currentYear: overallPerformanceState.currentYear,
    selectedQuarter: overallPerformanceState.selectedQuarter,
    selectedYear: overallPerformanceState.selectedYear,
    overallPerformanceRange: overallPerformanceState.overallPerformanceRange,
    compareSelectedYear: overallPerformanceState.compareSelectedYear,
    compareSelectedQuarter: overallPerformanceState.compareSelectedQuarter,
    compareSelectedYearForYTD: overallPerformanceState.compareSelectedYearForYTD,
    compareSelectedQuarterForYTD: overallPerformanceState.compareSelectedQuarterForYTD,
    compareOverallPerformanceRangeTableOne:
      overallPerformanceState.compareOverallPerformanceRangeTableOne,
    overallPerformanceYTDRange: overallPerformanceState.overallPerformanceYTDRange,
    compareOverallPerformanceRangeYTD: overallPerformanceState.compareOverallPerformanceRangeYTD,
  })
);

const overallPerformanceSubBranchCombinedData = createSelector(
  selectOverallPerformanceSubBranchState,
  (overallPerformanceState) => ({
    type: overallPerformanceState.type,
    currentQuarter: overallPerformanceState.currentQuarter,
    currentYear: overallPerformanceState.currentYear,
    selectedQuarter: overallPerformanceState.selectedQuarter,
    selectedYear: overallPerformanceState.selectedYear,
    overallPerformanceSubBranchRange: overallPerformanceState.overallPerformanceSubBranchRange,
    compareSelectedYear: overallPerformanceState.compareSelectedYear,
    compareSelectedQuarter: overallPerformanceState.compareSelectedQuarter,
    compareSelectedYearForYTD: overallPerformanceState.compareSelectedYearForYTD,
    compareSelectedQuarterForYTD: overallPerformanceState.compareSelectedQuarterForYTD,
    compareOverallPerformanceRangeTableOne:
      overallPerformanceState.compareOverallPerformanceSubBranchRangeTableOne,
    overallPerformanceYTDRange: overallPerformanceState.overallPerformanceYTDSubBranchRange,
    compareOverallPerformanceRangeYTD:
      overallPerformanceState.compareOverallPerformanceSubBranchRangeYTD,
  })
);

const getCalendarYear = (state) => state?.calendar;

export const selectors = {
  datePickerCombinedData,
  paidSearchCombinedData,
  overallPerformanceCombinedData,
  audienceAnalysisCombinedData,
  getCalendarYear,
  channeledOppsCombinedData,
  subBranchDashOppsByChannelCombinedData,
  overallPerformanceSubBranchCombinedData,
  performanceOverviewSubBranchCombinedData,
};

export default selectors;
